import $ from 'jquery';

class Search {
    constructor() {
        this.init()
    }

    init() {
        $('.js-open-search').on('click', (e) => {
            e.preventDefault();

            $('.js-search-input').toggleClass('show');
        });

        $('#searchform').submit(() => {
            if ($.trim($("#s").val()) === "") {
                $('.js-search-input').toggleClass('show');
                return false;
            }
        });
    }
}

module.exports = Search;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/search.js